export default __webpack_public_path__ + "static/media/035-monument of the martyr.95877214.svg";